import { useState } from 'react';
import Modal from './Modal';
import { Fld, Sel, TextA } from './Fields';
import { MAINT_TYPES, PRIORITIES, MAINT_STATUSES } from '../lib/constants';

const EMPTY = {
  vid: '',
  type: 'Oil Change',
  priority: 'Medium',
  status: 'Scheduled',
  sched: '',
  done: '',
  tech: '',
  estCost: '',
  actCost: '',
  odo: '',
  nextOdo: '',
  nextDate: '',
  notes: '',
  parts: '',
};

export default function MaintForm({ initial, onSave, onClose, fleet }) {
  const [m, setM] = useState(initial ? { ...EMPTY, ...initial } : EMPTY);
  const [saving, setSaving] = useState(false);
  const upd = (k, val) => setM((p) => ({ ...p, [k]: val }));
  const car = fleet.find((c) => c.id === m.vid);

  async function handleSave() {
    if (!m.vid) {
      alert('Please select a vehicle.');
      return;
    }
    setSaving(true);
    await onSave(m);
    setSaving(false);
  }

  return (
    <Modal title={initial?.id ? 'Edit Maintenance Record' : 'Log Maintenance'} onClose={onClose} wide testId="maint-form-modal">
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12 }}>
        <div style={{ gridColumn: '1/-1' }}>
          <Sel
            testId="mf-vehicle"
            label="Vehicle"
            value={m.vid}
            onChange={(e) => upd('vid', e.target.value)}
            required
            opts={[{ v: '', l: '-- Select vehicle --' }, ...fleet.map((c) => ({ v: c.id, l: `${c.brand} ${c.model} (${c.plate || c.id})` }))]}
          />
          {car && (
            <div style={{ padding: '10px 12px', background: '#EFF6FF', borderRadius: 8, fontSize: 12, color: '#1E40AF', marginTop: -8, marginBottom: 14 }}>
              <strong>
                {car.brand} {car.model}
              </strong>{' '}
              · {car.yr} · Status: {car.status} · {(car.odometer || 0).toLocaleString()} miles
            </div>
          )}
        </div>
        <Sel testId="mf-type" label="Maintenance Type" value={m.type} onChange={(e) => upd('type', e.target.value)} opts={MAINT_TYPES} />
        <Sel testId="mf-priority" label="Priority" value={m.priority} onChange={(e) => upd('priority', e.target.value)} opts={PRIORITIES} />
        <Sel testId="mf-status" label="Status" value={m.status} onChange={(e) => upd('status', e.target.value)} opts={MAINT_STATUSES} />
        <Fld testId="mf-tech" label="Technician / Shop" value={m.tech} onChange={(e) => upd('tech', e.target.value)} ph="DFW Auto Center" />
        <Fld testId="mf-sched" label="Scheduled Date" type="date" value={m.sched} onChange={(e) => upd('sched', e.target.value)} required />
        <Fld label="Completed Date" type="date" value={m.done} onChange={(e) => upd('done', e.target.value)} />
        <Fld testId="mf-estcost" label="Estimated Cost ($)" type="number" value={m.estCost} onChange={(e) => upd('estCost', e.target.value)} min={0} step="0.01" />
        <Fld label="Actual Cost ($)" type="number" value={m.actCost} onChange={(e) => upd('actCost', e.target.value)} min={0} step="0.01" />
        <Fld label="Odometer at Service" type="number" value={m.odo} onChange={(e) => upd('odo', e.target.value)} min={0} />
        <Fld label="Next Service Mileage" type="number" value={m.nextOdo} onChange={(e) => upd('nextOdo', e.target.value)} min={0} />
        <Fld label="Next Service Date" type="date" value={m.nextDate} onChange={(e) => upd('nextDate', e.target.value)} />
        <div style={{ gridColumn: '1/-1' }}>
          <TextA label="Notes" value={m.notes} onChange={(e) => upd('notes', e.target.value)} rows={2} />
          <TextA label="Parts Used" value={m.parts} onChange={(e) => upd('parts', e.target.value)} rows={2} />
        </div>
      </div>
      <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 10, marginTop: 16, paddingTop: 16, borderTop: '1px solid #E2E8F0' }}>
        <button onClick={onClose} className="btn-ghost" data-testid="mf-cancel">
          Cancel
        </button>
        <button onClick={handleSave} className="btn-red" disabled={saving} data-testid="mf-save">
          {saving ? 'Saving...' : initial?.id ? 'Save Changes' : 'Log Record'}
        </button>
      </div>
    </Modal>
  );
}
